export default (ordered: number, estimated: number): boolean => ordered >= estimated;



// WEBPACK FOOTER //
// ./src/domain/orders/isDisabledFromEstimation.ts